var map = {
	"./demos/basic/index.ts": 21149,
	"./demos/group/index.ts": 26334,
	"./demos/lazy/index.ts": 42978,
	"./demos/size/index.ts": 26476,
	"./demos/slots/index.ts": 84641,
	"./demos/status/index.ts": 66228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19073;